module.exports = __webpack_public_path__ + "img/FinTurno-admin.22b47ca7.png";